import { render, staticRenderFns } from "./importMessage.vue?vue&type=template&id=32294096&scoped=true"
import script from "./importMessage.vue?vue&type=script&lang=js"
export * from "./importMessage.vue?vue&type=script&lang=js"
import style0 from "./importMessage.vue?vue&type=style&index=0&id=32294096&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32294096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32294096')) {
      api.createRecord('32294096', component.options)
    } else {
      api.reload('32294096', component.options)
    }
    module.hot.accept("./importMessage.vue?vue&type=template&id=32294096&scoped=true", function () {
      api.rerender('32294096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/customerOrder/importMessage.vue"
export default component.exports